import { render, staticRenderFns } from "./CourseListFilters.vue?vue&type=template&id=61c5c256&"
import script from "./CourseListFilters.vue?vue&type=script&lang=js&"
export * from "./CourseListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CourseListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports